import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BACKBONE_URL } from '../../shared/constants';

@Injectable({
  providedIn: 'root'
})
export class PharmacyService {

  constructor(private httpClient: HttpClient) { }

  public getRecordCounts() {
    let address = BACKBONE_URL + `Pharmacy/count`;
    return this.httpClient.get(address);
  }

  public getCompactList() {
    let address = `${BACKBONE_URL}Pharmacy/compactlist`;
    return this.httpClient.get(address);
  }
}
